const mode = {
    development:"DEV",
    test:"TEST",
    production:"PROD",
    old: "https://api.osvitabezmezh.com.ua",
  };

export const MODE = mode.development